// Sized in em, not a fixed h-*, so it always scales with the CTA's own font-size
const CtaArrowIcon = ({
  className = 'h-[1.35em] transition-transform duration-300 group-hover:translate-x-1.5 ml-0.5',
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-hidden="true"
    viewBox="0 0 38 38"
  >
    <path d="M29.9 20v.3a31 31 0 0 0-8.8 9.8l-2-1.5c2.3-3.4 4.5-6 6.7-7.5-1.4.1-3 .3-5.2.3H9.9V19h10.7c2.1 0 3.8 0 5.2.2-2.2-1.5-4.4-4-6.6-7.4l1.9-1.6a31 31 0 0 0 8.8 9.9z"></path>
  </svg>
);

export default CtaArrowIcon;
